import { ButtonIcon } from 'mission-control-common-components';
import { ToastContainer } from 'react-toastify';
import styled, { css } from 'styled-components';

import { ReactComponent as ErrorIcon } from '../../assets/images/errorAlertCircle.svg';

export const commonErrorMessageLinkStyles = css`
  & a {
    color: ${({ theme }): string => theme.admanColors!.blue.solid};
    font-weight: 500;
    padding: 0 ${({ theme }): string => theme.admanSpacers!.spacer2px};

    &:hover {
      cursor: pointer;
    }
  }
`;

export const AlertCloseButtonStyled = styled(ButtonIcon)`
  flex: 0 0 24px;
  opacity: 0.3;

  svg {
    width: 16px;
    height: 16px;
    margin-top: ${({ theme }): string => theme.spacers!.spacer03};
  }
`;
export const AlertHeaderStyled = styled.div`
  display: flex;
`;

export const AlertTextContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  padding-left: ${({ theme }): string => theme.spacers!.spacer02};
`;

export const TitleStyled = styled.span`
  font-family: InspireTWDC;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: -0.1px;
  display: flex;
  align-items: center;
  padding-top: 2px;
`;
export const AlertContainerStyled = styled.div`
  padding: ${({ theme }): string => theme.spacers!.spacer02};
  padding-right: 0;
`;

export const AlertTextStyled = styled.div`
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg[1]};
  font-family: InspireTWDC;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  width: 200px;
  ${commonErrorMessageLinkStyles}
`;

export const ToastContainerStyled = styled(ToastContainer)`
  // Raised above react-toastify's 1em default to clear AdBuilder's composer-sdk footer buttons.
  // Note: & targets the SAME root element react-toastify assigns this class to (not a descendant).
  &.Toastify__toast-container--bottom-right {
    bottom: ${({ theme }): string => theme.spacers!.spacer09};
  }

  .Toastify__toast {
    border-radius: 8px;
    box-shadow: 0 0 32px -8px rgb(23 29 35 / 25%);
    width: 287px;
    background: ${({ theme }): string => theme.colors!.colorWhite};
  }

  .Toastify__toast-body {
    padding: 2px 0;
  }

  .Toastify__toast--success {
    color: ${({ theme }): string => theme.admanColors!.green.light.fg[1]};
  }

  .Toastify__toast--warning {
    border-color: ${({ theme }): string => theme.admanColors!.yellow.dark.bg0[1]};
    color: ${({ theme }): string => theme.admanColors!.yellow.dark.bg0[1]};
  }

  .Toastify__toast--error {
    color: ${({ theme }): string => theme.admanColors!.red.dark.fg[2]};
  }

  .Toastify__toast--info {
    border-color: ${({ theme }): string => theme.admanColors!.blue.dark.bg[4]};
    color: ${({ theme }): string => theme.admanColors!.blue.light.fg[1]};
  }
`;

export const Error = styled(ErrorIcon)(
  ({ theme: { admanColors } }) => css`
    fill: ${admanColors!.red.dark.fg[2]};
  `
);
